import { AlertTriangle } from "lucide-react";
import { useRef } from "react";

import Ajustes from "./Ajustes";
import CampanhasNucleo from "./campanhas/CampanhasNucleo";
import FaixaStatus from "./FaixaStatus";
import ListaCampanhas from "./ListaCampanhas";
import LocalizacaoRaio from "./LocalizacaoRaio";
import OQueFalta from "./OQueFalta";

/**
 * Estado "conectada", de cima para baixo: o que está ligado, o que falta
 * para o anúncio vender, as campanhas criadas pelo Núcleo (com o botão
 * Impulsionar), o resultado (gasto × pedidos), a área do anúncio e os ajustes. Saldo, pagamento e localização viram itens do "o que falta";
 * aqui em cima só fica o aviso de leitura que falhou.
 */
export default function Conectada({ situacao, campanhas, dias, onDias, podeGerir, podeConectar, onMudou }) {
  const mapaRef = useRef(null);
  const conexao = situacao.conexao;
  const falhaDeLeitura = (situacao.avisos || []).find((a) => a.tipo === "leitura");
  const irParaMapa = () => mapaRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });

  return (
    <div className="space-y-5">
      <FaixaStatus conexao={conexao} instagramLegivel={situacao.instagram_legivel} saldoMinimo={situacao.saldo_minimo_centavos ?? 2000}
        podeGerir={podeGerir} onMudou={onMudou} />
      {falhaDeLeitura && (
        <div className="flex items-start gap-2 rounded-lg border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-sm" data-e2e="meta-avisos">
          <AlertTriangle className="w-4 h-4 text-amber-600 mt-0.5 shrink-0" /> <span>{falhaDeLeitura.texto}</span>
        </div>
      )}
      <OQueFalta situacao={situacao} onIrParaMapa={irParaMapa} />
      <CampanhasNucleo conexao={conexao} podeGerir={podeGerir} recarregarEm={conexao.ultimo_sync_em} />
      <ListaCampanhas dados={campanhas} dias={dias} onDias={onDias} />
      <div ref={mapaRef}>
        <LocalizacaoRaio key={conexao.conectada_em || "mapa"} conexao={conexao} endereco={situacao.endereco_loja}
          podeGerir={podeGerir} onSalvo={onMudou} />
      </div>
      <Ajustes conexao={conexao} podeGerir={podeGerir} podeDesfazer={podeConectar} onMudou={onMudou} />
    </div>
  );
}
